// import DatePickerLocale from 'rmc-date-picker/lib/locale/en_US';

export default {
  okText: 'Ok',
  dismissText: 'Avbryt',
  extra: 'vÃ¤nligen vÃ¤lj',
  // DatePickerLocale,
  year: '',
  month: '',
  day: '',
  hour: '',
  minute: '',
  am: 'AM',
  pm: 'PM'
};
